import APIController from '../core-api-controller';

export const getUserAffiliateDataApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/client_user/users/user_affiliate_data${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};
